const c = (...args) => typeof window !== 'undefined' && window.clarity?.(...args);

export const clarityIdentify = (username) => c('identify', username);
export const clarityEvent    = (name)     => c('event', name);
